import { useTableContext } from "@/common/contexts/Table.context";
import { ArrowBackIcon } from "../icon";
import CustomTypography from "../Typography/CustomTypography";

export default function ResetFiltersButton() {
  const { resetFilters, filtersChanges } = useTableContext();
  const onResetClick = () => {
    resetFilters();
  };
  return filtersChanges > 0 ? (
    <button
      className="h-10  text-primary px-3 rounded-lg flex justify-between gap-2 items-center  bg-primaryDim hover:bg-primary hover:text-white transition"
      onClick={onResetClick}
    >
      <ArrowBackIcon />
      <CustomTypography as="span" className="text-inherit text-nowrap">
        Reset Filters
      </CustomTypography>
    </button>
  ) : (
    <div className="w-0 h-0" />
  );
}
